import { toast } from "react-toastify";
import { executePost, ExportExecutePost } from "../ServiceMethods";
import { SessionTimeout } from "../ErrorMessages";
import { removeUserCredentials } from "../LocalStorage";

export const VoucherTransactionsApi = async (data, cb) => {
  try {
    const vouchertransaction = await executePost(
      "/businessuser/transaction",
      data
    );
    const vouchertransactionData = vouchertransaction.data
      ? vouchertransaction.data
      : {};
    return vouchertransactionData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};

export const VoucherExportApi = async (data, cb) => {
  try {
    const VoucherExport = await ExportExecutePost(
      "/businessuser/transaction",
      data
    );
    const VoucherExportData = VoucherExport.data ? VoucherExport.data : {};
    return VoucherExportData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
